export const DELIVERY_FEE_LABEL = 'Delivery Fee for Orders Below Minimum (£)'
export const DELIVERY_FEE_HELP =
  'This fee will be added when this customer’s order is below their Minimum Order. Once the Minimum Order is reached, delivery is £0. No minimum means no delivery fee. Amounts exclude VAT.'
export const VENUE_DELIVERY_FEE_LABEL = 'Delivery Fee Below Minimum (ex VAT)'
export const VENUE_DELIVERY_FEE_HELP =
  'Added when the basket is below the minimum. Once the minimum is reached, delivery is £0. No minimum means no delivery fee. Amounts exclude VAT.'
